export enum BookedEnum {
  FALSE,
  TRUE,
}
